<template>
	<container>
		<ArticleListings :entries="entries">
			<template slot="listing" slot-scope="{ entry }">
				<a :href="entry.url" target="_blank" class="news-listing">
					<figure class="lead-image">
						<img :src="entry.leadImage">
					</figure>
					<div class="meta">
						<strong>News</strong> {{ entry.postDate | date }}
					</div>
					<div class="title">{{ entry.title }}</div>
				</a>

			</template>
		</ArticleListings>

	</container>
</template>

<script>

	import moment from 'moment'
	import ArticleListings from '@/components/ArticleListings'

	export default {
		name: 'News',
		props: {
			entries: {
				type: Array,
				default () {
					return []
				}
			}
		},
		components: { ArticleListings },
		filters: {
			date (value) {
				const date = moment(value)
				if(date.isValid()) {
					return date.format("MMM DD, YYYY")
				}
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import "responsive-font";

	.news-listing {
		@include responsive-font(10);
		color:inherit; text-decoration:none;
	}

	.lead-image {
		display:flex; justify-content:center; align-items: center; background:#F6F8F9; height:14em;
		@include media(small, large) {
			min-height:25vw;
		}
		img {
			max-width:20em; max-height:10em; width:auto; height:auto;
		}
	}

	.title {
		@include responsive-font(20);
		display:block; text-decoration:none; color:#3D3D3D; line-height:1.4;
	}

	.meta {
		@include responsive-font(13);
		display:flex; align-items:center; color:rgba(#09253B, .4); margin-top:1em;
		strong {
			color:#FDB913; text-transform:uppercase; font-weight:600; margin-right:.5em;
		}

	}

</style>



// WEBPACK FOOTER //
// src/components/NewsListings.vue